import admission from "../assets/admission.jpg";
import graduators from "../assets/graduators.jpg";
import workshop from "../assets/program-img2.jpg";

function formatDate(date) {
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    })
    .replace(/ /g, " ");
}

const now = new Date();

export const EVENTS = [
  {
    id: 1,
    title: "Admission Window Now Open",
    description:
      "The admission window for the current academic year is officially open. Apply now and secure your spot!",
    image: admission,
    category: "academic",
    time: "9:00 AM",
    location: "Main Campus",
    status: "upcoming",
    featured: true,
    dateISO: new Date(now.getTime() + 1 * 24 * 3600 * 1000).toISOString(),
  },
  {
    id: 2,
    title: "Graduation Ceremony 2025",
    description: "Join us to celebrate the remarkable achievements of our graduating students.",
    fullDescription: `
We are delighted to announce the Graduation Ceremony for the Class of 2024/2025, which will take place on **Saturday, 18th October 2025, at 8:00 AM**, right here at **JR Institute of Information Technology, Sakina – Arusha**.

Join us as we celebrate the hard work, dedication, and achievements of our graduates from various programs, including **Information Technology**, **Business Administration**, and more.

The event will feature:

🎖️ Award presentations to outstanding students  
🎓 Certificate distribution to all graduates  
🗣️ Inspirational speeches from distinguished guests  
🎉 Special performances and celebrations  

This is a momentous occasion for our students, staff, families, and community. **All are warmly welcome** to witness and share in this proud moment as we send off our graduates to begin their next chapter of success!
    `,
    image: graduators,
    category: "graduation",
    time: "8:00 AM",
    location: "JR Institute of Information Technology, Sakina – Arusha",
    status: "upcoming",
    featured: true,
    dateISO: new Date("2025-10-18T08:00:00Z").toISOString(),
  },
  {
    id: 3,
    title: "Leadership Development Workshop",
    description:
      "Enhance your leadership skills in our interactive Saturday workshop led by industry experts.",
    image: workshop,
    category: "workshop",
    time: "10:00 AM",
    location: "Conference Room A",
    status: "upcoming",
    featured: false,
    dateISO: new Date(now.getTime() + 10 * 24 * 3600 * 1000).toISOString(),
  },
];

export function getEventsList() {
  return EVENTS.map((e) => ({ ...e, date: formatDate(new Date(e.dateISO)) }));
}

export function getEventById(id) {
  const numeric = Number(id);
  const event = EVENTS.find((e) => e.id === numeric);
  return event
    ? { ...event, date: formatDate(new Date(event.dateISO)) }
    : undefined;
}
